import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { I18nModule } from '@spartacus/core';
import { SearchBoxModule } from '../../../search-box/search-box.module';
import { CustomPipesModule } from '../../pipes/custom-pipes.module';
import { ContractPriceGroupModule } from '../contract-price-group/contract-price-group.module';
import { ContractModule } from '../contract/contract.module';
import { QuickOrderComponent } from './quick-order/quick-order.component';

@NgModule({
  declarations: [QuickOrderComponent],
  imports: [
    CommonModule,
    SearchBoxModule,
    NgbModule,
    I18nModule,
    CustomPipesModule,
    ContractModule,
    ContractPriceGroupModule,
  ],
  exports: [QuickOrderComponent],
})
export class QuickOrderModule {}
